import React, { useMemo } from "react";
import "./MobileBottomNav.css";

export default function MobileBottomNav({ currentView, onNavigate, historyType = "overview" , favoritesType = "food"}) {
  const v = useMemo(() => String(currentView || "").toLowerCase(), [currentView]);

  const has = (...needles) => needles.some((n) => n && v.includes(String(n).toLowerCase()));

  // Active mapping supports shared views (favorites/history) + sub-views like "food_log"
  const isActive = (view) => {
    const fav = String(favoritesType || "").toLowerCase();
    const hist = String(historyType || "").toLowerCase();

    // Shared views should keep their category highlighted
    if (has("favorites") || has("favorite")) {
      if (view === "exercise") return fav === "exercise";
      if (view === "food") return fav !== "exercise";
      if (view === "profile") return false;
    }

    if (has("history")) {
      if (view === "exercise") return hist === "exercise";
      if (view === "food") return hist === "food";
      if (view === "profile") return hist === "weight";
    }

    if (view === "dashboard") return has("dashboard", "home");
    if (view === "calendar") return has("calendar");

    if (view === "exercise") return has("exercise", "workout", "workouts");
    if (view === "food") return has("food", "meal", "nutrition");

    if (view === "goals") return has("goal", "goals") || has("habit", "habits") || has("coach") || has("coach_programs");

    if (view === "profile") {
      // Settings bucket
      if (has("profile", "device", "devices", "weight", "settings", "admin", "trainer", "message", "messages")) return true;
      if (has("history") && hist === "weight") return true;
      return false;
    }

    return v === view;
  };

  const items = [
    { view: "dashboard", label: "Home", icon: "🏠" },
    { view: "calendar", label: "Calendar", icon: "📅" },
    { view: "exercise", label: "Workouts", icon: "🏋️" },
    { view: "food", label: "Meals", icon: "🍽️" },
    { view: "coach_programs", label: "Health", icon: "⚕️" },
    ];

  return (
    <nav className="mnav" aria-label="Bottom navigation">
      {items.map((it) => (
        <button
          key={it.view}
          type="button"
          className={`mnav-item ${isActive(it.view) ? "active" : ""}`}
          onClick={() => onNavigate(it.view)}
        >
          <div className="mnav-icon" aria-hidden="true">
            {it.icon}
          </div>
          <div className="mnav-label">{it.label}</div>
        </button>
      ))}
    </nav>
  );
}
